import React, { useState, useEffect } from 'react';
import TimestampAgo from '../../atoms/timestamp/timestampAgo';
const LogElement = ({ data}) => {
    const [newElement,setNewElent]=useState(null);
    const printType=(t)=>{
        let classN="logtype type";
        let cod;
        switch(t){
          case "error":
          case "ERROR":
            classN+="--error";
            cod="E";
          break;  
          case "logs":
            classN+="--log";
            cod="L";
          break;
          case "action":
            classN+="--action";
            cod="A";
          break;
          case "INFO":
            classN+="--info";
            cod="I";
          break;
          case "WARN":
            classN+="--warning";
            cod="W";
          break;
          case "connected":
            classN+="--success";
            cod="C";
          break;
          case "not-connected":
            classN+="--disconnected";
            cod="N";
          break;
          case "warning":
            classN+="--warning";
            cod="W";
        }
        return (
          <div className={classN}>{cod}</div>
        );
    }
    const printTime=(t)=>{
        let d=new Date(t);
        const year=d.getFullYear(); 
        const month=(d.getMonth()+1).toString().padStart(2,0);
        const day =(d.getDate()).toString().padStart(2,0);
        const hour=d.getHours();
        const min=(d.getMinutes()).toString().padStart(2,0);
        const sec=(d.getSeconds()).toString().padStart(2,0);
        const formatted = `${day}/${month}/${year} ${hour}:${min}:${sec}`;
        return (<div className="logtime">{formatted}</div>);
    }
    const extractElement=(el)=>{
        switch(el.type.toLowerCase()){
            case "error":
                setNewElent (
                <div className="log-element">
                  <div className="logtitle">
                    {printType(el.type)} {printTime(el.time)}
                    <div className="float-right"><TimestampAgo value={el.time} /></div>
                  </div>
                  <div className="log-original"><b>{JSON.stringify(el.value)}</b></div>
                </div>
              );
            break;
            case "logs":
                setNewElent (
                <div className="log-original">
                  {el.value.map((log)=>(
                    <div className="logsubitem logtitle">
                      {printType(log.type)} {log.message}
                      <div className="float-right"><TimestampAgo value={el.value.time} /></div>
                    </div>
                  ))}
                </div>
              );
            break;
            case "agent":
              if(el.value.value.hostName){
                let t="not-connected";
                if(el.value.value.connected){
                  var date = new Date(el.value.value.time);
                  var now=new Date();
                  let sec=Math.floor((now-Math.floor(date))/1000);
                  if(sec<30)
                    t="connected";
                  else
                    t="warning";
                }
                setNewElent (
                  <div className="log-element">
                  <div className="logtitle">
                    {printType(t)} {printTime(el.value.value.time)} &nbsp;
                      {<b>{el.value.value.hostName}</b>}
                      <div className="float-right"><TimestampAgo value={el.value.value.time} /></div>
                      <div>Host address:{el.value.value.hostAddress}</div>
                      <div>OS Info:{JSON.stringify(el.value.value.osInfo)}</div>
                      <div>Hw Info:{JSON.stringify(el.value.value.hwInfo)}</div>
                      <div>Interfaces:{JSON.stringify(el.value.value.interfaces)}</div>
                  </div>
                </div>
                )
              }
              break;
            case "action":
                setNewElent(
                  <div className="log-element">
                    <div className="logtitle">
                      {printType(el.type)} {printTime(el.time)} &nbsp;
                        {el.value.action && <b>{el.value.action} - {el.value.status}</b>}
                        {el.value.cloudStatus && <b>{"Cloud status - "+el.value.cloudStatus}</b>}
                        <div className="float-right"><TimestampAgo value={(el.value.value.time?el.value.value.time:el.time)} /></div>
                    </div>
                    <div className="log-original">{JSON.stringify(el.value)}</div>
                  </div>
                );
            break;
            case "info":
              if(el.value.type.toLowerCase()=="info"){
                setNewElent(<div className="log-element">
                <div className="logtitle">
                  {printType(el.value.type)} {printTime(el.time)} &nbsp;
                  <div className="float-right"><TimestampAgo value={el.time} /></div>
                </div>
                <div className="log-original">{JSON.stringify(el.value)}</div>
                </div>);
        
              }else{
                setNewElent(<div className="log-element">
                  <div className="logtitle">
                    {printType(el.value.type)} {printTime(el.time)} &nbsp;
                    <div className="float-right"><TimestampAgo value={el.value.time} /></div>
                  </div>
                  <div className="log-original">{JSON.stringify(el.value)}</div>
                </div>);
              }
              break;
            case "warn":
              if(el.value.type=="WARN"){
                setNewElent(<div className="log-element">
                <div className="logtitle">
                  {printType(el.value.type)} {printTime(el.time)} &nbsp;
                  <div className="float-right"><TimestampAgo value={el.time} /></div>
                </div>
                <div className="log-original">{JSON.stringify(el.value)}</div>
                </div>);
              }
            break;
          }
    }
    useEffect(()=>{
        if(data){
            // data.forEach((el) => {
              extractElement(data);
            // });
        }
    },[data])

    return (
        <div>
            {newElement && <div>{newElement}</div>}
        </div>
    );

}

export default LogElement;
